import React from 'react';
import { useI18n } from '../i18n/index.jsx';
import { tradeRows, specRows } from '../productOptions.js';

// Product detail blocks shared by the public product page, the admin
// review and the wizard's summary: trade details as a grid,
// specifications as a table, key advantages, usage/application.

export function TradeGrid({ listing }) {
  const { t, lang } = useI18n();
  const rows = tradeRows(listing, t, lang);
  if (!rows.length) return null;
  return (
    <dl className="trade-grid">
      {rows.map(([k, v]) => (
        <div key={k} className="trade-cell">
          <dt>{t(`product.fields.${k}`)}</dt>
          <dd>{v}</dd>
        </div>
      ))}
    </dl>
  );
}

export function SpecsTable({ listing }) {
  const { t, lang } = useI18n();
  const rows = specRows(listing, t, lang);
  if (!rows.length) return null;
  return (
    <table className="specs-table">
      <tbody>
        {rows.map(([k, v, key], i) => (
          <tr key={i} className={key ? 'is-key' : ''}><th scope="row">{k}</th><td>{v}</td></tr>
        ))}
      </tbody>
    </table>
  );
}

export function Advantages({ listing }) {
  const items = (listing.advantages || []).filter(Boolean);
  if (!items.length) return null;
  return <ul className="advantages">{items.map((a, i) => <li key={i}>{a}</li>)}</ul>;
}

// Everything below the description, with headings. `level` = heading tag.
export default function ProductFacts({ listing, level = 'h2' }) {
  const { t } = useI18n();
  const H = level;
  const hasSpecs = specRows(listing, t, 'fr').length > 0;
  const hasTrade = tradeRows(listing, t, 'fr').length > 0;
  const hasAdv = (listing.advantages || []).some(Boolean);
  return (
    <>
      {hasAdv && <section className="product-block"><H>{t('product.advantages')}</H><Advantages listing={listing} /></section>}
      {hasSpecs && <section className="product-block"><H>{t('product.specifications')}</H><SpecsTable listing={listing} /></section>}
      {hasTrade && <section className="product-block"><H>{t('product.tradeDetails')}</H><TradeGrid listing={listing} /></section>}
      {listing.applications && <section className="product-block"><H>{t('product.fields.applications')}</H><p className="pre-line">{listing.applications}</p></section>}
    </>
  );
}
